/* Brisa Polar · JS compartido (galería, combos y disparo del formulario contra entrega).
   Cada sección que lo necesita lo incluye; la guarda de abajo evita ejecutarlo dos veces. */
(function () {
  if (window.BP) return;

  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  var BP = (window.BP = { qty: 1 });

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function cop(n) { return '$' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }

  /* ---------- Combos: una sola variante, cantidad real y descuento automático de Shopify ---------- */
  function currentBundle() {
    var box = document.querySelector('[data-bp-bundles]');
    var pick = null;
    if (box) {
      $$('.bp-bundle', box).forEach(function (l) { if (Number(l.getAttribute('data-qty')) === BP.qty) pick = l; });
      if (!pick) pick = box.querySelector('.bp-bundle');
    }
    if (pick) {
      return {
        unit: Number(pick.getAttribute('data-unit')) / 100,
        variant: pick.getAttribute('data-variant'),
        qty: Number(pick.getAttribute('data-qty')),
        discount: Number(pick.getAttribute('data-discount')) || 0
      };
    }
    var f = document.querySelector('[data-bp-form]');
    return f
      ? { unit: Number(f.getAttribute('data-unit')) / 100, variant: f.getAttribute('data-variant'), qty: BP.qty, discount: 0 }
      : { unit: 0, variant: null, qty: BP.qty, discount: 0 };
  }

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    $$('form[action$="/cart/add"] input[name="id"], [data-bp-form] input[name="id"]').forEach(function (i) { i.value = variantId; });
    $$('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    /* Releasit lee este input al disparar COD: manda la cantidad real del combo */
    $$('input[name="quantity"]').forEach(function (i) { i.value = String(q); i.setAttribute('value', String(q)); });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var node = document.querySelector(RELEASIT_SELECTORS[i]);
      if (node) return node;
    }
    return null;
  }

  BP.render = function () {
    var cur = currentBundle();
    var total = cur.unit * cur.qty - cur.discount;
    $$('[data-bp-bundles]').forEach(function (box) {
      $$('.bp-bundle', box).forEach(function (label) {
        var q = Number(label.getAttribute('data-qty'));
        var d = Number(label.getAttribute('data-discount')) || 0;
        var lu = Number(label.getAttribute('data-unit')) / 100;
        var net = lu * q - d;
        var input = label.querySelector('input');
        input.checked = q === BP.qty;
        label.classList.toggle('bp-on', input.checked);
        var bp = label.querySelector('[data-bp-price]');
        if (bp) bp.textContent = cop(net);
        var st = label.querySelector('[data-bp-strike]');
        if (st) st.textContent = cop(lu * q);
        var note = label.querySelector('[data-bp-note]');
        if (note) {
          note.textContent = (label.getAttribute('data-desc') || '')
            .replace('{ahorro}', cop(d))
            .replace('{c_u}', cop(net / q));
        }
      });
    });
    $$('[data-bp-cta]').forEach(function (btn) {
      var tpl = btn.getAttribute('data-tpl');
      var l1 = btn.querySelector('[data-bp-l1]');
      if (l1 && tpl) l1.textContent = tpl.replace('{total}', cop(total));
    });
    setVariantOnAllForms(cur.variant, cur.qty);
  };

  function triggerCOD() {
    var cur = currentBundle();
    setVariantOnAllForms(cur.variant, cur.qty);
    setTimeout(function () {
      var btn = findReleasitButton();
      if (btn) { btn.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          /* Último recurso (no re-lee la variante) */
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.bp-bundle')) { BP.qty = Number(t.value) || 1; BP.render(); }
  });
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var cta = t.closest('[data-bp-cta]');
    if (cta) { e.preventDefault(); triggerCOD(); }
  });

  /* ---------- Galería del Hero ---------- */
  function initGallery(root) {
    if (root.getAttribute('data-bp-ready')) return;
    root.setAttribute('data-bp-ready', '1');
    var slides = $$('[data-bp-slide]', root);
    var thumbs = $$('[data-bp-thumb]', root);
    var main = root.querySelector('[data-bp-gmain]');
    var cur = 0;
    function show(i) {
      if (!slides.length) return;
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (sl, k) { sl.classList.toggle('bp-on', k === cur); });
      thumbs.forEach(function (b, k) {
        b.classList.toggle('bp-on', k === cur);
        b.setAttribute('aria-current', k === cur ? 'true' : 'false');
      });
    }
    thumbs.forEach(function (b, k) { b.addEventListener('click', function () { show(k); }); });
    $$('[data-bp-nav]', root).forEach(function (b) {
      b.addEventListener('click', function () { show(cur + Number(b.getAttribute('data-bp-nav'))); });
    });
    if (main) {
      var x0 = null;
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }
  }

  BP.init = function () {
    BP.render();
    $$('[data-bp-hero]').forEach(initGallery);
  };
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  ready(BP.init);
  document.addEventListener('shopify:section:load', BP.init);
})();
